import React from "react";
import PropTypes from "prop-types";

export const CommentSkeleton = ({ depth = 0 }) => (
  <div
    className={`p-2 dark:bg-gray-800 bg-gray-50 mb-2 rounded-bl-md ${
      depth > 0
        ? "ml-4 border-l-2 border-gray-200"
        : "border-l-4 border-blue-200"
    }`}
  >
    <div className="animate-pulse">
      <div className="flex items-center gap-2 mb-2">
        <div className="h-4 bg-gray-200 rounded w-24 dark:bg-gray-700"></div>
      </div>
      <div className="space-y-2">
        <div className="h-3 bg-gray-200 rounded w-3/4 dark:bg-gray-700"></div>
        <div className="h-3 bg-gray-200 rounded w-1/2 dark:bg-gray-700"></div>
      </div>
      <div className="mt-2 flex items-center gap-2">
        <div className="h-3 bg-gray-200 rounded w-16 dark:bg-gray-700"></div>
        <div className="h-3 bg-gray-200 rounded w-16 dark:bg-gray-700"></div>
      </div>
    </div>
  </div>
);

CommentSkeleton.propTypes = {
  depth: PropTypes.number,
};

export const CommentErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    const handleError = (error) => {
      console.error("Comment Error:", error);
      setHasError(true);
    };

    window.addEventListener("error", handleError);
    return () => window.removeEventListener("error", handleError);
  }, []);

  if (hasError) {
    return (
      <div className="text-red-500 p-2 text-sm dark:text-red-400">
        Error loading comment. Please try refreshing the page.
      </div>
    );
  }

  return children;
};
